import React, { useState } from 'react';
import { MessageCircle, X, Phone } from 'lucide-react';

const FloatingChat = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="floating-chat">
      {/* Expanded Panel */}
      {isOpen && (
        <div className="mb-4 w-72 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden animate-in slide-in-from-bottom-4 fade-in duration-200" data-testid="chat-panel">
          <div className="bg-black p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-white font-bold text-sm">Auto Concierge Enterprises</p>
                <p className="text-gray-400 text-xs">Typically replies instantly</p>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-white">
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>
          <div className="p-4 space-y-3">
            <div className="bg-gray-100 rounded-lg p-3 text-sm text-gray-700 max-w-[85%]">
              <p className="font-semibold text-black mb-1">Your Concierge</p>
              <p>How can ACE help you today? Call, text, or leave a message.</p>
            </div>
            
            <a
              href="tel:6788463009"
              className="flex items-center gap-3 w-full p-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-semibold"
              data-testid="chat-call-btn"
            >
              <Phone className="h-4 w-4" />
              Call (678) 846-3009
            </a>
            
            <a
              href="sms:6788463009"
              className="flex items-center gap-3 w-full p-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-semibold"
              data-testid="chat-text-btn"
            >
              <MessageCircle className="h-4 w-4" />
              Text (678) 846-3009
            </a>

            <a
              href="https://wa.me/16788463009?text=Hi%20ACE%2C%20I%27d%20like%20to%20learn%20more%20about%20your%20services."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 w-full p-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold"
              data-testid="chat-whatsapp-btn"
            >
              <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" /></svg>
              WhatsApp
            </a>
          </div>
          <div className="px-4 pb-3">
            <p className="text-[10px] text-gray-400 text-center">ACE responds Mon-Sat, same day</p>
          </div>
        </div>
      )}

      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`h-14 w-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
          isOpen ? 'bg-gray-800 rotate-90' : 'bg-red-600 hover:bg-red-700 hover:scale-110'
        }`}
        data-testid="floating-chat-btn"
      >
        {isOpen ? (
          <X className="h-6 w-6 text-white" />
        ) : (
          <MessageCircle className="h-6 w-6 text-white" />
        )}
      </button>
    </div>
  );
};

export default FloatingChat;
